import type { PropsWithChildren } from "react";
import * as styles from "./Alert.styles.ts";
import { CloseButton } from "src/components/CloseButton/CloseButton.tsx";
import { type HTMLMotionProps, motion } from "framer-motion";
import { StatusIcon } from "src/components/StatusIcon/StatusIcon.tsx";

export type AlertSeverity = "info" | "success" | "error" | "warning";

export type AlertProps = PropsWithChildren<
  {
    severity?: AlertSeverity;
    showCloseButton?: boolean;
    onClose?: () => void;
    progress?: number;
    pulsate?: boolean;
    pulsateIcon?: boolean;
  } & HTMLMotionProps<"div">
>;

export const Alert = (props: AlertProps) => {
  const {
    severity = "info",
    children,
    showCloseButton = false,
    pulsate = false,
    pulsateIcon = false,
    progress,
    onClose,
    ...rest
  } = props;

  return (
    <motion.div css={styles.container({ severity, pulsate })} {...rest}>
      <div css={styles.statusIconContainer}>
        <StatusIcon pulsate={pulsateIcon} severity={severity} />
      </div>

      <div css={styles.content}>{children}</div>
      {showCloseButton && (
        <CloseButton onClick={onClose} css={styles.closeButton} />
      )}
      {progress != null && (
        <div css={styles.progress({ severity, progress })} />
      )}
    </motion.div>
  );
};
